export enum ApiEndpoint {
  ResourceController = '/api/company',
}

export enum AuthEndpoint {}

